module.exports = __webpack_public_path__ + "img/2.c7d94798.png";